import React from "react";
import { render } from "react-dom";
import Wishlist from "../widgets/wishlist";

const widget = document.querySelector(".wishlist-widget");
if (widget) render(<Wishlist elem={widget} />, widget);
